module.exports = function getSalesTaxPeriodAbbreviation(period) {
    switch (period) {
    case 'month':
        return 'm'
    case 'quarter':
        return 'q'
    case 'halfYear':
        return 'h'
    default:
        return 'y'
    }
}
